import formYoutubeCategoryContent from './formYoutubeCategoryContent';

export default {
  title: 'Youtube Category Form',
  attributeName: 'youtubeCategoryForm',
  getURL: 'mainHubs/mainHubId/youtube/categories',
  createURL: 'mainHubs/mainHubId/youtube/categories',
  updateURL: 'mainHubs/mainHubId/youtube/categories',
  // additionaMetadataURL: 'appId/additionalMetadata/AppContent',
  sessionParams: ['mainHubId'],
  autoUpdate: false,
  removeURL: '',
  idAttribute: 'id',
  noArea:true,
  idUpdate:true,
  goBack:true,
  // updateReduxWhen:['appTeams','teamsToCameraContentTable','teams','composeExperienceObj'],
  formConfig: [formYoutubeCategoryContent],
};

